import Repository from "./Repository";

export default {
  itemsModel(payload) {
    return Repository.post(``, payload);
  },
};
